import { AdminFeedItemStatusEnum } from "../schema";
import { AdminFeedItemInfo } from "../views/AdminFeedItemDetailsView/AdminFeedItemDetailsView";

export const isFeedItemApproved = (feedItem: AdminFeedItemInfo) => feedItem.status === AdminFeedItemStatusEnum.APPROVED;
